import { Button, cn, SofiaMark } from "@coval/ui"

interface AskSofiaButtonProps {
  onClick: () => void
  className?: string
}

/**
 * Shared entrypoint button for handing a task to Sofia (metric SQL authoring,
 * run/simulation summaries, …). Rendered as a regular secondary button so it
 * reads as an action, not a subtle affordance.
 */
export function AskSofiaButton({ onClick, className }: AskSofiaButtonProps) {
  return (
    <Button
      type="button"
      variant="secondary"
      onClick={onClick}
      className={cn("gap-1.5", className)}
    >
      <SofiaMark size={16} />
      Ask Sofia
    </Button>
  )
}
